import React, { useState, useEffect } from 'react';
import { 
  LoadingOverlay, 
  Stack,
} from '@mantine/core';
import { useApp } from '../../context/AppContext';
import SubscriptionCheckout from '../SubscriptionCheckout';
import './StudioManagement.css';
import BusinessInfoSettings from './BusinessInfoSettings';
import BusinessHoursSettings from './BusinessHoursSettings';
import BillingSettings from './BillingSettings';
import { useSalon } from '../../context/SalonContext';
import { useMediaQuery } from '@mantine/hooks';
function StudioManagement({onSubmit}) {
  const { updateSalon } = useApp();
  const { businessInfo, currentUser } = useSalon();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isLoading, setIsLoading] = useState(true);
  const [editingSection, setEditingSection] = useState(null); // 'info' or 'hours'

  useEffect(() => {
    if (businessInfo) {
      setIsLoading(false);
    }
  }, [businessInfo]);

  const handleUpdate = async (updatedData) => {
    try {
      setIsLoading(true);

      if (!updatedData) {
        onSubmit(null);
        return;
      }

      const response = await updateSalon(updatedData);
      if (response) {
        onSubmit(response);
        setEditingSection(null);
      }
    } catch (error) {
      console.error('Error updating:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoadingOverlay visible={isLoading} />
      <Stack py={{ base: 'sm', sm: 'lg' }} px={{ base: 0, sm: 'md' }}>
        <Stack gap={isMobile ? 'sm' : 'xl' }>
          { businessInfo?.status !== 'Active' && currentUser?.role === 'Owner' && <SubscriptionCheckout />}
          <BusinessInfoSettings 
            editingSection={editingSection}
            setEditingSection={setEditingSection}
            handleUpdate={handleUpdate}
          />
          <BusinessHoursSettings 
            editingSection={editingSection}
            setEditingSection={setEditingSection}
            handleUpdate={handleUpdate}
          />
          {currentUser?.role === 'Owner' && <BillingSettings />}
        </Stack>
      </Stack>
    </>
  );
}

export default StudioManagement; 